export default {
  version: 'master',
  compilation: '220751'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1472
// module chunks = 22